import { render, staticRenderFns } from "./DxGridWithSearch.vue?vue&type=template&id=5c4e1fc9&scoped=true&"
import script from "./DxGridWithSearch.vue?vue&type=script&lang=js&"
export * from "./DxGridWithSearch.vue?vue&type=script&lang=js&"
import style0 from "./DxGridWithSearch.vue?vue&type=style&index=0&id=5c4e1fc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4e1fc9",
  null
  
)

export default component.exports